<template>
  <div class="rating-stars">
    <StarIcon
      v-for="star in 5"
      :key="star"
      class="rating-stars__star-icon"
      :class="{
        'rating-stars__star-icon--hover': !readOnly && star <= hover,
        'rating-stars__star-icon--selected': star <= value,
      }"
      @click="handleRatingSelected(star)"
      @mouseover="setHover(star)"
      @mouseleave="setHover(0)"
    />
  </div>
</template>
<script>
import StarIcon from '@/assets/icons/star_icon.svg'

export default {
  name: 'RatingStars',
  components: {
    StarIcon,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: 0,
    }
  },
  methods: {
    handleRatingSelected(star) {
      if (!this.readOnly) this.$emit('input', star)
    },
    setHover(star) {
      this.hover = star
    },
  },
}
</script>
<style lang="scss" scoped>
.rating-stars {
  display: flex;
  gap: 2px;

  &__star-icon {
    &--hover,
    &--selected {
      path {
        fill: var(--larea-networking);
        stroke: var(--larea-networking);
      }
    }

    &--hover {
      cursor: pointer;
      animation: pulse 0.5s infinite;
      @keyframes pulse {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }
    }
  }
}
</style>
